<!-- <meta http-equiv="refresh" content="180"/> -->
<div *ngIf="campaign" class="main" fxLayoutAlign="center center" fxLayout="column">
  <!-- <button (click)="setSizes()">44444456</button>  -->

  <div fxLayout="row" style="position: fixed; top: 0; width: 100%;" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="center">
      <h1 *ngIf="campaign.visibleDestination == true" style="color: #FFF; font-weight: bold; margin-right: 110px;margin-top: 48px; font-size: 40px;">
        <small *ngIf="campaign.liabilities > 0" style="color: #fff1ff">
         עד כה התחייבו <br><b>{{campaign.liabilities}} ערכות</b>
        </small>
       
      </h1>
           <h1 *ngIf="campaign.visibleDestination == true" style=" color: #FFF; font-weight: bold; margin-right: 110px;margin-top: 0px; font-size: 40px;; -webkit-transform: rotate(356deg)">
       
        <small  style="color: #fff1ff"> היעד </small> 
        <br>
        {{campaign.destination}} ערכות
         
      </h1>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center">
      <h1 *ngIf="campaign.lastAttached" style="text-align: center;color: #FFF; font-weight: bold;text-indent: 10px;margin-top: 15px; font-size: 50px">
        ר' {{campaign.lastAttached.attachedName}}
        <br>
        <small style="font-weight: bold;color: #fff1ff">{{campaign.lastAttached.count}} ערכות</small>
      </h1>
    </div>
    <div fxLayout="column" fxLayoutAlign="center">
      <!-- <h1 *ngIf="campaign.visibleDestination == true">{{campaign.liabilities}}</h1> -->
    </div>
  </div>


  <div style="position: fixed; top: 0;" fxLayoutAlign="center center" fxLayout="row">

  </div>

  <div class="buttom" #boxesContainer fxLayout="row" style="max-height:70%;">
    <div fxLayout="row reverse" fxLayoutAlign="center center" fxLayoutGap="0px">
      <mat-card style="font-size:initial !important"  *ngFor="let ca of campaign.duplicationCampaignAttacheds" [style.width.px]="boxWidth" [style.height.px]="boxHeight" fxLayoutAlign="center center">
        <mat-card-content  [style.marginRight.px]="marginRight"  [style.marginLeft.px]="(-marginRight)"  [style.fontSize.px]="fontsize">
          <h2 style="margin: 0px auto; font-size: inherit;font-weight: bold; -webkit-transform: rotate(356deg);" [style.marginTop.px]="marginTopBox"> {{ ca.attachedName }}
            <br>
            <!-- <small style="font-weight: bold; margin-top: 5px;font-size: 85%; -webkit-transform: rotate(356deg);">{{ca.count}}</small> -->
          </h2>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Copyright 2019 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  </div>
</div>